import { render, staticRenderFns } from "./ExhibitionMain.vue?vue&type=template&id=140cf8fc&"
import script from "./ExhibitionMain.vue?vue&type=script&lang=js&"
export * from "./ExhibitionMain.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140cf8fc')) {
      api.createRecord('140cf8fc', component.options)
    } else {
      api.reload('140cf8fc', component.options)
    }
    module.hot.accept("./ExhibitionMain.vue?vue&type=template&id=140cf8fc&", function () {
      api.rerender('140cf8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Visitors/ExhibitionMain.vue"
export default component.exports